__turbopack_context__.v({
  "enter": "BlogMdxHeading-module-scss-module__78OIcG__enter",
  "exit": "BlogMdxHeading-module-scss-module__78OIcG__exit",
  "fade-in": "BlogMdxHeading-module-scss-module__78OIcG__fade-in",
  "fade-out": "BlogMdxHeading-module-scss-module__78OIcG__fade-out",
  "fade-out-80": "BlogMdxHeading-module-scss-module__78OIcG__fade-out-80",
  "label": "BlogMdxHeading-module-scss-module__78OIcG__label",
  "slide-in-from-bottom": "BlogMdxHeading-module-scss-module__78OIcG__slide-in-from-bottom",
  "slide-in-from-left": "BlogMdxHeading-module-scss-module__78OIcG__slide-in-from-left",
  "slide-in-from-right": "BlogMdxHeading-module-scss-module__78OIcG__slide-in-from-right",
  "slide-in-from-top": "BlogMdxHeading-module-scss-module__78OIcG__slide-in-from-top",
  "slide-out-to-bottom": "BlogMdxHeading-module-scss-module__78OIcG__slide-out-to-bottom",
  "slide-out-to-left": "BlogMdxHeading-module-scss-module__78OIcG__slide-out-to-left",
  "slide-out-to-right": "BlogMdxHeading-module-scss-module__78OIcG__slide-out-to-right",
  "slide-out-to-top": "BlogMdxHeading-module-scss-module__78OIcG__slide-out-to-top",
  "zoom-in": "BlogMdxHeading-module-scss-module__78OIcG__zoom-in",
  "zoom-out": "BlogMdxHeading-module-scss-module__78OIcG__zoom-out",
});
